export default __webpack_public_path__ + "static/media/14.33b3a780.pdf";